/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedMeasurementUnitProvider_user$ref = any;
export type SbRespAppliedFilters_user$ref = any;
export type SbRespAppliedFilters_user = {
    readonly " $fragmentRefs": SbSharedMeasurementUnitProvider_user$ref;
    readonly " $refType": SbRespAppliedFilters_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespAppliedFilters_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedMeasurementUnitProvider_user",
      "args": null
    }
  ]
};
(node as any).hash = '1bfb05c02214c19d1643769e11afc5fe';
export default node;
